import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M20.4 13.2V2.4h-1.2v10.8h1.2zm-1.2 1.2v7.2h1.2v-7.2h-1.2zM12.6 7.2V2.4h-1.2v4.8h1.2zm-1.2 1.2v13.2h1.2V8.4h-1.2zM4.8 10.8V2.4H3.6v8.4h1.2zM3.6 12v9.6h1.2V12H3.6z" fill="#000" /><path fill="#000" d="M1.2 12h6v1.2h-6zM16.8 14.4h6v1.2h-6zM9 6h6v1.2H9z" /></svg>;